import React, { useEffect } from "react";
import { useMastersContext } from "../../../../../contexts/masters.context";
import SelectFormControl from "../../../shared/form-controls/SelectFormControl";

function CategorySecondaryOptionForm({
  formData,
  setFormData,
  categoryData,
  decoMethodsData,
}) {
  const handleInputChange = (event) => {
    setFormData({
      ...formData,
      [event.currentTarget.name]: Number(event.currentTarget.value),
    });
  };

  return (
    <div className="container" style={{ textAlign: "initial" }}>
      <div className="row justify-content-md-center">
        <div className="col-md">
          <form>
            <SelectFormControl
              label="Category"
              id="categoryID"
              name="CategoryID"
              options={categoryData}
              optionLabelField="name"
              optionValueField="category_ID"
              value={formData.CategoryID || -1}
              onChange={handleInputChange}
            />
            <SelectFormControl
              label="Primary Deco Method"
              id="primaryDecoID"
              name="PrimaryDecoID"
              options={decoMethodsData}
              optionLabelField="name"
              optionValueField="dM_ID"
              value={formData.PrimaryDecoID || -1}
              onChange={handleInputChange}
            />
            <SelectFormControl
              label="Secondary Deco Method"
              id="secondaryDecoID"
              name="SecondaryDecoID"
              options={decoMethodsData}
              optionLabelField="name"
              optionValueField="dM_ID"
              value={formData.SecondaryDecoID || -1}
              onChange={handleInputChange}
            />
          </form>
        </div>
      </div>
    </div>
  );
}

export default CategorySecondaryOptionForm;
